import type { ColumnDef } from '@/lib/tanstack-table';
import type { AssignmentLine } from 'src/api/rpc/hooks/procurement/useReplenishmentSuggestions';
import {
  DEPENDENT_USAGE_COLUMN_ID,
  USAGE_12_COLUMN_ID,
} from '../utils/buyerBoardColumns';
import { usageQuantity, type UsagePart } from '../utils/lineUsage';
import { LineUsageCell } from './LineUsageCell';

function usageColumn(id: string, part: UsagePart): ColumnDef<AssignmentLine> {
  return {
    id,
    size: 90,
    accessorFn: (l) => usageQuantity(l.usage, part),
    meta: { align: 'right' },
    cell: ({ row }) => <LineUsageCell usage={row.original.usage} part={part} />,
  };
}

/** Headers come from the saved view (`buyerBoardColumns`). */
export const usageColumns: ColumnDef<AssignmentLine>[] = [
  usageColumn(USAGE_12_COLUMN_ID, 'own'),
  usageColumn(DEPENDENT_USAGE_COLUMN_ID, 'dependent'),
];
